import {http} from '@/http/index.js';

async function getProfile() {
  return http.get('/girl').then((response) => response.data.data);
}

export {getProfile};
